import './styles.sass'

import React, { FC } from 'react';

export interface IEmptiness {
  icon?: any
  content?: string
}

const Emptiness: FC<IEmptiness> = ({ icon, content }) => {
  return (
    <div className="item-is-nothing">
      <img src={icon} alt="avatar" />
      {content && (
        <span>{content}</span>
      )}
    </div>
  );
};

export default Emptiness;
